export const HIGHLIGHT_COLOR = "#D90000";